// Client form validation errors mapping

export const defaultControlErrors = {
  serverError: 'SERVER_ERROR',
  required: 'REQUIRED',
  email: 'INVALID_EMAIL',
  min: 'BELOW_ALLOWED_VALUE',
  invalidUnp: 'INVALID_UNP_ERROR',
  invalidUnpStatus: 'INVALID_STATUS_UNP_ERROR',
  max: 'ABOVE_ALLOWED_VALUE',
  bsDate: 'INVALID_DATE',
  minDate: 'MIN_DATE',
  maxDate: 'MAX_DATE',
  pattern: 'PATTERN_ERROR',
  cyrillicFio: 'FIO_CYRILLIC_ONLY_ERROR',
  cyrillicFioEdges: 'FIO_CYRILLIC_EDGES_ERROR',
  minlength: 'MINLENGTH_ERROR',
  maxlength: 'MAXLENGTH_ERROR',
  maxDeclarationLength: 'MAX_DECLARATION_ITEMS_LENGTH',
  forbiddenChar: 'FORBIDDEN_CHAR',
  validatePhoneNumber: 'INCORRECT_PHONE_NUMBER',
  mobile: 'NOT_MOBILE_PHONE',
  digits: 'DIGITS_ONLY',
  number: 'NUMBER_ONLY',
  range: 'VALUE_OUT_OF_RANGE',
  deliveryInterval: 'DELIVERY_INTERVAL_NOT_LESS_THEN_HOUR',
  rangeLength: 'LENGTH_OUT_OF_RANGE',
  equal: 'VALUE_NOT_EQUAL',
  notEqual: 'VALUE_EQUAL',
  alreadyUsed: 'ALREADY_USED',
  gt: 'BELOW_ALLOWED_VALUE',
  iban: 'INVALID_IBAN',
  bicErr: 'BIC_ERROR',
  fullNameSymbol: 'FIO_SYMBOL_TYPE_ERROR',
  fullNameLength: 'FIO_LENGTH_ERROR',
  ibanAlreadyExist: 'IBAN_ALREADY_EXIST',
  parcelWeight: 'PARCEL_WEIGHT_ERROR',
  invalidPhoneCode: 'INVALID_PHONE_CODE',
  notInRangeFromZeroToThousand: 'NOT_IN_RANGE_FROM_ZERO_TO_THOUSAND',
  notInteger: 'NOT_INTEGER',
  invalidContact: 'INVALID_CONTACT',
};
